import React from "react";
import "./FocusArea.css";
const FocusArea = () => {
  return (
    <>
      <div className="focus-main">
        <div className="heading">
          <h2 className="focus-emea-header">Focus Area</h2>
          <div className="header_focus_emea">
          <img src="images/Home/focusarea_line.png" alt="header_line" className="header_focus_line_img" />
        </div>
        </div>
        
        <div className="emea-body">
          <div className="map-image">
            <img src="/images/Emeanew/FocusArea.png" className="world-map" />
          </div>
          <div className="south-container">
            <div className="box-south">
              <img src="/images/new/South.png" className="south-img" />

              <h3 className="heading-south">South</h3>
              <ul className="list-south">
                <li className="li-south">
                  Teachnical Learnings: SAP HANA Migration, Brownfield, AI, Data{" "}
                  <br></br>and AI, Integration SONG{" "}
                </li>
                <li className="li-south">
                  Application areas: Full Stack, UX/UI Design
                </li>
                <li className="li-south">
                  Industry learnings: Retail, consumer, and utilities
                </li>
                <li className="li-south">
                  Leadership Development: Management, Sales, and Delivery skills
                </li>
              </ul>
            </div>
          </div>
          <div className="italy-container">
            <div className="box-italy">
              <img src="/images/new/ITLY.png" className="italy-img" />

              <h3 className="heading-italy">Italy</h3>
              <ul className="list-italy">
                <li className="li-italy">
                  Industry training requirement:Financial <br></br> Services,
                  Banking, and Insurance
                </li>
                <li className="li-italy">Gen AI</li>
                <li className="li-italy">Security</li>
                <li className="li-italy">Java Testing</li>
              </ul>
            </div>
          </div>
          <div className="West-container">
            <div className="box-west">
              <img src="/images/new/West.png" className="west-img" />

              <h3 className="heading-west">West</h3>
              <div className="data-inlist">
                <div className="first-list">
                  <ul>
                    <li className="li-west">
                      Delivery Fundamentals <br></br>
                      Program 4.0
                    </li>
                    <li className="li-west">Problem Sloving skills</li>
                    <li className="li-west">
                      MyCompetency <br></br>
                      Framework
                    </li>
                  </ul>
                </div>
                <div className="second-list">
                  <ul>
                    <li className="li-west">SAP</li>
                    <li className="li-west">Oracle</li>
                    <li className="li-west">Gen AI</li>
                    <li className="li-west">
                      Leadership <br></br>
                      Training
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="ukia-container">
            <div className="box-ukia">
              <img src="/images/new/Ukia.png" className="ukia-img" />

              <h3 className="heading-ukia">UKIA</h3>
              <ul className="list-ukia">
                <li className="li-ukia">Java Spring Training and AI</li>
                <li className="li-ukia">
                  Industry Learning: H&PS and Financial Services
                </li>
              </ul>
            </div>
          </div>
          <div className="middle-container">
            <div className="box-middle">
              <img src="/images/new/Middle.png" className="middle-img" />

              <h3 className="heading-middle">Egypt</h3>
              <ul className="list-middle">
                <li className="li-middle">SAP and Oracle</li>
                <li className="li-middle">
                  Develop a learning strategy for ATC Egypt
                </li>
              </ul>
            </div>
          </div>
          <div className="east-container">
            <div className="box-east">
              <img src="/images/new/CentralEast.png" className="east-img" />

              <h3 className="heading-east">East/Central</h3>
              <ul className="list-east">
                <li className="li-east">Industry learning</li>
                <li className="li-east">
                  Collaborating with Global Learning team for EMES East/Central
                  as suggested by the leads
                </li>
              </ul>
            </div>
          </div>
          <div className="north-container">
            <div className="box-north">
              <img src="/images/new/North.png" className="north-img" />

              <h3 className="heading-north">North</h3>
              <ul className="list-north">
                <li className="li-north">Industry learning -Reporting</li>
                <li className="li-north">SAP</li>
                <li className="li-north">Java</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FocusArea;
